import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className, y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className, delay = 0 }) => (
  <motion.div
    initial="hidden"
    animate="show"
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.09, delayChildren: delay } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className }) => (
  <motion.div
    variants={{ hidden: { opacity: 0, y: 22 }, show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: EASE } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ number, label }) => (
  <div className="flex items-center gap-3">
    <span className="font-mono-code text-xs text-[#E50914]">{number}</span>
    <span className="h-px w-10 bg-[#E50914]/60" />
    <span className="font-mono-code text-xs uppercase tracking-[0.3em] text-zinc-500">
      {label}
    </span>
  </div>
);

export const SectionHeading = ({ number, label, title, accent }) => (
  <div className="relative space-y-6">
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -left-2 -top-14 select-none font-display text-[7rem] font-extrabold leading-none text-[#F4F4F6]/[0.035] sm:-top-20 sm:text-[10rem]"
    >
      {number}
    </span>
    <Reveal>
      <Eyebrow number={number} label={label} />
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-3xl font-bold tracking-tight text-zinc-100 sm:text-4xl lg:text-5xl">
        {title} {accent && <span className="text-[#E50914]">{accent}</span>}
      </h2>
    </Reveal>
  </div>
);
